// extracted by mini-css-extract-plugin
export var copyableField = "_ob-4";
export var customerBadge = "_ob-0";
export var customerInfoTitle = "_ob-2";
export var details = "_ob-1";
export var dropdownContainer = "_ob-5";
export var dropdownImage = "_ob-6";
export var editAssigneeForm = "_ob-a";
export var editButton = "_ob-3";
export var email = "_ob-7";
export var hidden = "_ob-d";
export var input = "_ob-8";
export var saveButton = "_ob-b";
export var shopifyIcon = "_ob-c";
export var suggestionBadge = "_ob-e";
export var suggestionText = "_ob-f";
export var username = "_ob-9";